export const colors = {
  buttons: {
    primary:
      'linear-gradient(243.83deg, rgba(148, 85, 25, 0.9) -22.78%, rgba(255, 221, 164, 0.9) 15.56%, rgba(205, 105, 3, 0.9) 46.24%, rgba(255, 208, 137, 0.9) 116.08%, rgba(255, 192, 127, 0.9) 157.62%, rgba(229, 151, 70, 0.9) 205.07%)',
    primaryHover: '#BE7510',
    secondary: '#D2A151',
    secondaryHover: '#E09720',
    dark: '#C07618',
    darkHover: '#7F4E0F',
    light: '#EFC689',
    text: '#FFFFFF',
  },
  text: {
    dark: '#1E0F00',
    accent: '#7D430A',
    light: '#5B3C14',
    active: '#AA6B09',
  },
  background: {
    light: '#FAFAFA',
    dark: '#E0D0B2',
    accent: '#E5DDC9',
    medium: '#E0D0B2',
    transparent: '#D9C59E',
    tooltip: '#FFF5DC',
  },
  elements: {
    primary: '#EEBD75',
    secondary: '#DEA754',
    accent: '#62543A',
    dark: '#995A00',
    skeletonPrimary: '#DEAA61',
    skeletonSecondary: '#E7C28E',
  },
  border: {
    primary: '#E0D0B2',
  },
  gradient: {
    fade: 'linear-gradient(90deg, #E0D0B2 40.38%, rgba(224, 208, 178, 0) 100%)',
  },
  accent: {
    success: '#387545',
    error: '#E5373A',
    soft: '#FFEBC3',
  },
  tags: {
    processing: '#E48E43',
    success: '#53882F',
    reject: '#CA6B54',
    transfer: '#FFD889',
    mint: '#A5622F',
    text: '#FFFFFF',
  },
};
